import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon BanquetDuotone
 */
export const BanquetDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M128,74.7c29.4,0,53.3,23.9,53.3,53.3s-23.9,53.3-53.3,53.3S74.7,157.4,74.7,128C74.7,98.6,98.6,74.7,128,74.7 M128,64.7 C93,64.7,64.7,93,64.7,128S93,191.3,128,191.3s63.3-28.3,63.3-63.3C191.3,93,163,64.7,128,64.7L128,64.7z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M128,74.7c29.4,0,53.3,23.9,53.3,53.3s-23.9,53.3-53.3,53.3S74.7,157.4,74.7,128C74.7,98.6,98.6,74.7,128,74.7"
      fill="currentColor"
    />
    <path
      d="M128,16.5c6.8,0,12.2,5.5,12.2,12.2S134.8,41,128,41c-6.8,0-12.3-5.5-12.3-12.3S121.2,16.5,128,16.5 M128,6.5 c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3s22.3-10,22.3-22.2c0,0,0,0,0,0C150.2,16.5,140.3,6.5,128,6.5z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M128,16.5c6.8,0,12.2,5.5,12.2,12.2S134.8,41,128,41c-6.8,0-12.3-5.5-12.3-12.3S121.2,16.5,128,16.5"
      fill="currentColor"
    />
    <path
      d="M227.3,115.7c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.2-5.5-12.2-12.3 C215,121.2,220.5,115.8,227.3,115.7 M227.3,105.7c-12.3,0-22.2,10-22.2,22.2s10,22.3,22.2,22.3s22.2-10,22.2-22.3 S239.5,105.7,227.3,105.7z"
      fill="currentColor"
    />
    <path
      d="M57.8,45.6c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0-3.2,1.3-6.4,3.6-8.7 C51.4,46.9,54.6,45.6,57.8,45.6 M57.8,35.6c-12.3,0-22.2,10-22.2,22.3c0,12.3,10,22.2,22.3,22.2s22.2-10,22.2-22.3 c0-5.9-2.4-11.6-6.5-15.7C69.4,37.9,63.7,35.6,57.8,35.6z"
      fill="currentColor"
    />
    <path
      d="M198.2,45.6c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0-3.2,1.3-6.4,3.6-8.7 C191.8,46.9,194.9,45.6,198.2,45.6 M198.2,35.6c-12.3,0-22.3,10-22.3,22.2s10,22.3,22.2,22.3s22.3-10,22.3-22.2 c0-5.9-2.3-11.6-6.5-15.7C209.8,37.9,204.1,35.6,198.2,35.6z"
      fill="currentColor"
    />
    <path
      d="M57.8,185.9c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3c0-3.2,1.3-6.4,3.6-8.6 C51.4,187.2,54.6,185.9,57.8,185.9 M57.8,175.9c-12.3,0-22.2,10-22.2,22.2c0,12.3,10,22.2,22.2,22.2s22.2-10,22.2-22.2 c0-5.9-2.3-11.6-6.5-15.7C69.4,178.3,63.7,175.9,57.8,175.9z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M57.8,185.9c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3 c0-3.2,1.3-6.4,3.6-8.6C51.4,187.2,54.6,185.9,57.8,185.9"
      fill="currentColor"
    />
    <path
      d="M57.8,45.6c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0-3.2,1.3-6.4,3.6-8.7 C51.4,46.9,54.6,45.6,57.8,45.6 M57.8,35.6c-12.3,0-22.2,10-22.2,22.3c0,12.3,10,22.2,22.3,22.2s22.2-10,22.2-22.3 c0-5.9-2.4-11.6-6.5-15.7C69.4,37.9,63.7,35.6,57.8,35.6z"
      fill="currentColor"
    />
    <path
      d="M128,215c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.2c0,0,0,0,0,0 C115.8,220.5,121.2,215,128,215 M128,205c-12.3,0-22.3,10-22.3,22.2c0,12.3,10,22.3,22.2,22.3c12.3,0,22.3-10,22.3-22.2c0,0,0,0,0,0 C150.2,215,140.3,205,128,205z"
      fill="currentColor"
    />
    <path
      d="M198.2,185.9c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3c0-3.2,1.3-6.4,3.6-8.6 C191.8,187.2,194.9,185.9,198.2,185.9 M198.2,175.9c-12.3,0-22.2,10-22.2,22.2c0,12.3,10,22.2,22.2,22.2c12.3,0,22.2-10,22.2-22.2 c0-5.9-2.3-11.6-6.5-15.7C209.7,178.3,204.1,175.9,198.2,175.9z"
      fill="currentColor"
    />
    <path
      d="M28.7,115.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C16.5,121.2,22,115.8,28.7,115.7 M28.7,105.7c-12.3,0-22.3,10-22.3,22.2s10,22.3,22.2,22.3S51,140.3,51,128l0,0 C51,115.7,41,105.7,28.7,105.7z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M227.3,115.7c6.8,0,12.2,5.5,12.2,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.2-5.5-12.2-12.3 C215,121.2,220.5,115.8,227.3,115.7"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M198.2,45.6c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0-3.2,1.3-6.4,3.6-8.7 C191.8,46.9,194.9,45.6,198.2,45.6"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M57.8,45.6c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0-3.2,1.3-6.4,3.6-8.7 C51.4,46.9,54.6,45.6,57.8,45.6"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M128,215c6.8,0,12.2,5.5,12.2,12.2s-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.2c0,0,0,0,0,0 C115.8,220.5,121.2,215,128,215"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M198.2,185.9c6.8,0,12.2,5.5,12.2,12.3c0,6.8-5.5,12.2-12.3,12.2c-6.8,0-12.2-5.5-12.2-12.3 c0-3.2,1.3-6.4,3.6-8.6C191.8,187.2,194.9,185.9,198.2,185.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M28.7,115.7c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C16.5,121.2,22,115.8,28.7,115.7"
      fill="currentColor"
    />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default BanquetDuotone;
